// The account the Audit page shows (audit guide ticket 02): the one the link
// names, else the one last chosen on this device, else the first. Memory is a
// hint: an account no longer assigned is passed over.

type AccountStorage = Pick<Storage, "getItem" | "setItem">;
const accountKey = (orgSlug: string) => `toolkit:audit-account:v1:${orgSlug}`;

const browserStorage = (): AccountStorage | undefined =>
  typeof window === "undefined" ? undefined : window.localStorage;

export function rememberAuditAccount(
  orgSlug: string,
  accountId: string,
  storage = browserStorage(),
) {
  try {
    storage?.setItem(accountKey(orgSlug), accountId);
  } catch {
    // A full or blocked storage only loses the hint.
  }
}

export function chooseAuditAccount<T extends { accountId: string }>(
  orgSlug: string,
  accounts: readonly T[],
  requested: string | undefined,
  storage = browserStorage(),
): T | undefined {
  const find = (id: string | null | undefined) =>
    id ? accounts.find((account) => account.accountId === id) : undefined;
  let remembered: string | null | undefined;
  try {
    remembered = storage?.getItem(accountKey(orgSlug));
  } catch {
    remembered = undefined;
  }
  return find(requested) ?? find(remembered) ?? accounts[0];
}
